module.exports = __webpack_public_path__ + "static/scale-model-of-vietnam-veterans-fountain-in-chicago-illinois-365f71aff3070d80154a494e5fa4592d.png";